module.exports = __webpack_public_path__ + "img/link.bca91e34.svg";